import React, {Component} from 'react';

class ReferFriend extends Component{
    state = {

    }

    render(){
        const overlayClasses = "custom-modal-overlay " + (this.props.open ? "show-custom-modal-overlay" : "hidden-custom-modal-overlay");
        const modalClasses = "custom-modal bgc-white bd bdrs-2 " + (this.props.open ? "show" : "hidden");
        return(
            <div class={overlayClasses}>
                <div class={modalClasses}>
                    <div class="custom-modal__title">
                        <h3 class="m-0 ta-c">Indicar um amigo</h3>
                    </div>
                    <div class="custom-modal__content">
                        <form action="" class="mB-30">
                            <div class="form-group peers jc-c col-md-12 m-0 p-0">
                                <div class="form-group col-md-12">
                                    <label for="inputName">Nome</label>
                                    <input class="form-control" name="inputName" placeholder="Nome da clínica" required="" type="text"/>
                                </div>
                                <div class="form-group col-md-12">
                                    <label for="inputContact">Contato</label>
                                    <input class="form-control" name="inputContact" placeholder="telefone de contato" required=""
                                        type="text"/>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="custom-modal__footer peers jc-c">
                        <button onClick={this.props.toggleModal} class="close-modal btn btn-muted mR-20 c-client-secondary" type="button">Cancelar</button>
                        <button onClick={this.props.toggleModal} class="btn btn-default" type="button">Enviar</button>
                    </div>
                </div>
            </div>
        )
    }
}

export default ReferFriend;


// WEBPACK FOOTER //
// ./src/pages/evolution/ReferFriend.js